<template>
  <div class="user_page">
    <h3 class="title-page">{{ $t("splitQr") }}</h3>
    <div>
      <div class="admin_container">
        <validation-observer
          tag="div"
          v-slot="{ handleSubmit }"
          ref="firstQrFormObs"
        >
          <div>
            <custom-input-text
              :loading="loading"
              :label="$t('oldQr')"
              @input="(val) => findByQr(val, 'firstQrData')"
              v-model="moveQrData.qrCode"
              rules="required"
              class="user_input no-margin"
            ></custom-input-text>
            <span v-if="firstQrData">
              {{ firstQrData.productName }} {{ firstQrData.count }}
              {{ firstQrData[`unit_type_name_${$i18n.locale}`] }}
            </span>
          </div>
          <custom-input-text
            v-model="moveQrData.count"
            rules="required"
            :label="$t('moveCount')"
            class="user_input no-margin"
          ></custom-input-text>
          <div class="pt-4 d-flex flex-wrap ma-n1 justify-end">
            <div class="pa-1">
              <v-btn
                @click="
                  () => {
                    moveQrData.new = true;
                    handleSubmit(save);
                  }
                "
                color="primary"
                >{{ $t("moveQr") }}
              </v-btn>
            </div>
            <div class="pa-1">
              <v-btn @click="handleSubmit(moveQrToExist)" color="primary">{{
                $t("moveQrToExist")
              }}</v-btn>
            </div>
          </div>
        </validation-observer>
      </div>
    </div>
    <v-dialog width="450" v-model="dialog">
      <v-card>
        <v-card-title>{{ $t("moveQrToExist") }}</v-card-title>
        <v-card-text>
          <validation-observer v-slot="{ handleSubmit }" ref="secondQrFormObs">
            <form @submit.prevent="handleSubmit(submit)">
              <div class="mb-2">
                <custom-input-text
                  v-model="moveQrData.count"
                  rules="required"
                  :label="$t('moveCount')"
                  class="user_input no-margin"
                ></custom-input-text>
              </div>
              <custom-input-text
                rules="required"
                :loading="loading"
                @input="(val) => findByQr(val, 'secondQrData')"
                class="user_input no-margin"
                :label="$t('existQr')"
                v-model="moveQrData.qrCode2"
              />
              <span v-if="secondQrData" class="d-inline-block mt-2">
                {{ secondQrData.productName }} {{ secondQrData.count }}
                {{ secondQrData[`unit_type_name_${$i18n.locale}`] }}
              </span>
              <div class="text-right mt-3">
                <v-btn type="submit" color="primary">Ok</v-btn>
              </div>
            </form>
          </validation-observer>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { debounce } from "@/utils/pureFunctions";
import { QrService } from "@/utils/QrService";
import { LotTemplate } from "@/utils/qr-template/LotTemplate";

const DEFAULT_QR_DATA = {
  count: null,
  new: true,
  qrCode: null,
  qrCode2: null,
};

export default {
  data() {
    return {
      dialog: false,
      firstQrData: null,
      secondQrData: null,
      loading: false,
      moveQrData: {
        ...DEFAULT_QR_DATA,
      },
    };
  },
  methods: {
    findByQr: debounce(async function (val, key) {
      this.loading = true;
      try {
        this[key] = await this.$store.dispatch("getInfoByQr", val);
      } catch (e) {
        this[key] = null;
      } finally {
        this.loading = false;
      }
    }, 300),
    moveQrToExist() {
      this.moveQrData.new = false;
      this.dialog = true;
    },
    clear() {
      this.moveQrData = { ...DEFAULT_QR_DATA };
      const { secondQrFormObs, firstQrFormObs } = this.$refs;
      this.firstQrData = null;
      this.secondQrData = null;
      firstQrFormObs.reset();
      if (secondQrFormObs) secondQrFormObs.reset();
    },

    save() {
      return new Promise((resolve, reject) => {
        this.showLoading();
        this.$http
          .post("product-item/split-product", this.moveQrData)
          .then(
            ({
              data: {
                data: { id },
              },
            }) => {
              const qrService = new QrService();
              const qrTemplate = new LotTemplate();
              qrTemplate.addQr(`{id: ${id}}`).then(() => {
                qrTemplate.addText(`Id: ${id}`);
                qrService.add(qrTemplate.data);
                qrService.show("qr");
              });
              this.clear();
              resolve();
            }
          )
          .catch((e) => {
            this.setResponseError({ error: e });
            reject(e);
          })
          .finally(() => {
            this.clearLoading();
          });
      });
    },
    async submit() {
      await this.save();
      this.dialog = false;
    },
  },
};
</script>
